/**
 * Reads the file name a download endpoint advertises in its
 * Content-Disposition header. Supports the RFC 5987 `filename*` form (used
 * when the name carries non-ASCII characters) and falls back to the plain
 * `filename` form, then to the caller's fallback.
 *
 * Pass `response.headers.get('content-disposition')`: the HTTP clients return
 * native `Headers`, indexing them is always `undefined`.
 */
export function contentDispositionFilename(
  contentDisposition: string | null | undefined,
  fallback = 'document'
): string {
  if (!contentDisposition) return fallback

  const encoded = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (encoded) {
    const decoded = decodeOrNull(encoded[1].trim())
    if (decoded) return decoded
  }

  const quoted = contentDisposition.match(/filename\s*=\s*"([^"]*)"/i)
  if (quoted && quoted[1].trim()) return quoted[1].trim()

  const bare = contentDisposition.match(/filename\s*=\s*([^;"]+)/i)
  if (bare && bare[1].trim()) return bare[1].trim()

  return fallback
}

function decodeOrNull(value: string): string | null {
  try {
    return decodeURIComponent(value)
  } catch {
    return null
  }
}
